import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'govuk-react-jsx';
import { useSelector } from 'react-redux';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import {
  getCompanyData,
  getBusinessVatData,
} from '../../features/pmc/pmcJourneySlice';
import { getUserDetails } from '../../features/dashboard/dashboardSlice';
import { completeRegistration } from '../../firebase';
import useTitle from '../../hooks/useTitle';

const PasswordCreated = () => {
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);

  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  useTitle(
    'landlordReg.Declaration.s14',
    'Declaration - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );
  const companyDataRedux = useSelector(getCompanyData);
  const businessVatDataRedux = useSelector(getBusinessVatData);
  const currentUserData = useSelector(getUserDetails);

  const history = useHistory();

  const handleBtnClick = () => {
    completeRegistration()
      .then(() => {
        history.push('/pmcReg/account-created');
      })
      .catch(() => {
        // TODO: Show error message
      });
  };

  return (
    <>
      <span className="govuk-caption-xl">
        {companyDataRedux && companyDataRedux.company_name}
        {businessVatDataRedux &&
          businessVatDataRedux?.target &&
          businessVatDataRedux.target.name}
        {currentUserData != null &&
          currentUserData.business_name != null &&
          currentUserData.business_name}
      </span>
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy('pmcReg.Declaration.s1', 'Declaration')}
      </h1>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'pmcReg.Declaration.s2',
          'You are creating an account to apply for EV chargepoints grants on behalf of your clients. It is your responsibility to advise them about the grants.'
        )}
      </p>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'pmcReg.Declaration.s3',
          'By continuing, you confirm that you have provided the correct information to the best of your knowledge.'
        )}
      </p>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'pmcReg.Declaration.s4',
          'If this information is incorrect or changes, your clients may not receive the grants.'
        )}
      </p>
      <div className="govuk-warning-text govuk-!-margin-top-7">
        <span className="govuk-warning-text__icon" aria-hidden="true">
          !
        </span>
        <strong className="govuk-warning-text__text">
          <span className="govuk-warning-text__assistive">Warning</span>
          <b>
            {copyProvider.getCopy(
              'pmcReg.Declaration.s5',
              'It is an offence to make a false declaration to obtain a grant you could be fined or prosecuted.'
            )}
          </b>
        </strong>
      </div>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'pmcReg.Declaration.s6',
          'If chosen for an audit, you agree to work with OZEV or its agents.'
        )}
      </p>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'pmcReg.Declaration.s7',
          'To find out how we use your information, '
        )}
        <a
          href="https://www.gov.uk/government/organisations/office-for-low-emission-vehicles/about/personal-information-charter"
          target="_blank"
          rel="noreferrer"
        >
          {copyProvider.getCopy(
            'pmcReg.Declaration.s8',
            ' read the OZEV personal information charter (opens in new tab).'
          )}
        </a>
      </p>
      <Button
        className="govuk-button-group govuk-!-margin-top-7"
        onClick={handleBtnClick}
      >
        {copyProvider.getCopy('pmcReg.Declaration.s9', 'Accept and continue')}
      </Button>
    </>
  );
};

export default PasswordCreated;
